import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';

import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';

import CloseButton from 'bento-ordering/base/ui_components/CloseButton';
import {
  ITEM_DESCRIPTION_AND_PRICES,
  MENU_ITEM_NAMES
} from 'styles/constants/appearanceSectionNames';

import StyledDialogTitle from 'components/StyledDialogTitle';
import StyledDialogContentText from 'components/StyledDialogContentText';
import { getPageBackgroundColor } from 'styles/helpers/getThemeStyles';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiTypography-h6': {
    fontWeight: theme.fonts.medium
  },
  '& .MuiDialog-paper': {
    backgroundColor: getPageBackgroundColor(theme),
    [theme.breakpoints.down('lg')]: {
      width: '90%',
      marginLeft: 0,
      marginRight: 0
    }
  }
}));

function NotificationModal({ children, onClose, title, body, fullWidth }) {
  const Children = React.Children.toArray(children);
  const titleStyles = { variant: MENU_ITEM_NAMES };

  const bodyStyles = { variant: ITEM_DESCRIPTION_AND_PRICES };

  return (
    <StyledDialog open onClose={onClose} maxWidth="xs" fullWidth={fullWidth}>
      <Box pt={1.5} pl={2.5} pr={2.5} pb={1.25}>
        <CloseButton autoFocus handleClick={onClose} />
        <StyledDialogTitle {...titleStyles}>{title}</StyledDialogTitle>
      </Box>
      {(body || !!Children.length) && (
        <DialogContent>
          {body && (
            <StyledDialogContentText {...bodyStyles}>
              {body}
            </StyledDialogContentText>
          )}
          {!!Children.length && (
            <DialogActions disableSpacing>{Children}</DialogActions>
          )}
        </DialogContent>
      )}
    </StyledDialog>
  );
}

NotificationModal.defaultProps = {
  fullWidth: false
};

NotificationModal.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string,
  fullWidth: PropTypes.bool
};

export default NotificationModal;
